module.exports = __webpack_public_path__ + "static/img/アセット 74@3x.fa2672f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 74@3x.png
// module id = z6xZ
// module chunks = 1